export enum A11yCustomValue {
  Date = 'Date',
  Hero = 'Hero',
  ListItem = 'List Item',
  Pagination = 'Pagination',
  Accordion = 'Accordion',
  List = 'List',
  Badge = 'Badge',
  Breadcrumb = 'Breadcrumb',
  BreadcrumbItem = 'Breadcrumb Item',
  Button = 'Button',
  ButtonToggle = 'Button Toggle',
  ButtonToggleGroup = 'Button Toggle Group',
  Dropdown = 'Dropdown',
  LiteTooltip = 'Lite Tooltip',
  Tag = 'Tag',
  Toast = 'Toast',
  Toolbar = 'Toolbar',
  Tooltip = 'Tooltip',
  StepperItem = 'Stepper Item',
  Stepper = 'Stepper',
  ResizePanel = 'Resize Panel',
  SplitPanel = 'Split Panel',
  HelpText = 'Help Text',
  Loader = 'Loader',
  ValueMin = '0',
  ValueMax = '100',
  Switch = 'Switch',
  FormErrorMessage = 'Form Error Message',
  ErrorMessage = 'Error Message',
  ErrorNotification = 'Error Notification Message',
  ErrorDescription = 'No Error Description',
  EmptyState = 'Empty State Message',
  EmptyStateDescription = 'No Empty State Description',
  Drawer = 'Drawer',
  CircularProgressBar = 'Circular Progress Bar',
  Card = 'Card',
  Avatar = 'Avatar',
  VerticalStepperItem = 'Vertical Stepper Item',
  Vertical = 'vertical',
  Horizontal = 'horizontal',
  Separator = 'Separator',
  Checkbox = 'Checkbox',
  TreeItem = 'Tree Item',
  Select = 'Select',
  Listbox = 'Listbox',
  CodeEditor = 'Code Editor',
  RichTextEditor = 'Rich Text Editor',
  SkeletonLoader = 'Skeleton Loader',
  Carousel = 'Carousel',
  SlideShow = 'Slideshow',
  InlineEdit = 'Inline Edit',
  Link = 'Link',
  Dialog = 'Dialog',
  FileUpload = 'File Upload',
  FilePreview = 'File Preview',
  FloatingPanel = 'Floating Panel',
  TabGroup = 'Tab Group',
  Grid = 'Table Data',
  GridRow = 'Grid Row',
  GridBody = 'Grid Body',
  GridHead = 'Grid Head',
  Input = 'Input',
  None = 'None',
  SideBar = 'Sidebar',
  InlineSidebar = 'Inline Sidebar',
  Slider = 'Slider',
  SlideToggle = 'Slide Toggle',
}